import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiUser } = FiIcons;

const ReviewsSection = ({ currentArea }) => {
  const reviews = [
    {
      name: "Sarah Mitchell",
      service: "Commercial Cleaning",
      rating: 5,
      text: "Diamond Cleaning has been maintaining our office building in " + currentArea + " for over a year now. Their attention to detail is exceptional and the staff are always professional.",
      date: "2 weeks ago"
    },
    {
      name: "James Thompson",
      service: "Domestic Cleaning",
      rating: 5,
      text: "Absolutely brilliant service! They clean our house fortnightly and always do an amazing job. Very reliable and trustworthy team.",
      date: "1 month ago"
    },
    {
      name: "Emma Wilson",
      service: "End of Tenancy",
      rating: 5,
      text: "Used Diamond Cleaning for our end of tenancy clean in " + currentArea + ". Got our full deposit back thanks to their thorough work. Highly recommend!",
      date: "3 weeks ago"
    },
    {
      name: "Michael Brown",
      service: "Commercial Cleaning",
      rating: 5,
      text: "We use them for our retirement property communal areas. They're always punctual, professional, and the residents love how clean everything is kept.",
      date: "1 week ago"
    },
    {
      name: "Lisa Davis",
      service: "Deep Cleaning",
      rating: 5,
      text: "Had a deep clean done before moving into our new home. The team was fantastic and left everything spotless. Great value for money!",
      date: "2 months ago"
    },
    {
      name: "Robert Clarke",
      service: "Restaurant Cleaning",
      rating: 5,
      text: "They clean our restaurant every night and maintain the highest standards. Essential for our business and they never let us down.",
      date: "1 month ago"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Customers Say About Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real reviews from satisfied customers across {currentArea} and surrounding areas
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <SafeIcon icon={FiUser} className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">{review.name}</h4>
                  <p className="text-sm text-gray-600">{review.service}</p>
                </div>
              </div>

              <div className="flex items-center mb-4">
                <div className="flex space-x-1 mr-2">
                  {[...Array(review.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
                  ))}
                </div>
                <span className="text-sm text-gray-500">{review.date}</span>
              </div>

              <p className="text-gray-700 leading-relaxed">"{review.text}"</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://share.google/xr3mZOVXjGPtaFHeP"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold"
          >
            <span>Read More Reviews on Google</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;